/**
 * Guard for Hiring (DA-5042): org admins, team managers and platform admins,
 * and only when the org has the Hiring flag on, which is the rule the backend
 * applies (src/service/hiring/hiringCore.ts resolveOwnerScope).
 *
 * The flag is a compliance switch rather than a preview toggle: an org gets a
 * feature that assesses job candidates with AI on purpose, so an org without it
 * must not reach these routes at all.
 */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useHiringAccessible } from '../pages/new-designs/tabs/hiring/access';

const HiringGuard: React.FC = () => {
  const allowed = useHiringAccessible();
  // Still asking the backend who this is.
  if (allowed === null) return null;
  return allowed ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default HiringGuard;
